<template>
  <PaymentConfirmation />
</template>

<script>
import PaymentConfirmation from '@/components/registerFormSteps/PaymentConfirmation'

export default {
  name: 'Confirmation',
  metaInfo: {
    title: `${process.env.VUE_APP_PAGE_TITLE} - Confirmt & Pay`
  },
  components: {
    PaymentConfirmation
  }
}
</script>
